import styled from 'styled-components'

const MarketoFormContainer = styled.div`
  background: ${p => p.theme.webMktPalette.background.gray};

  ${p => p.theme.breakpoints.up('sm')} {
    padding: 32px 0;
  }

  > div {
    width: 792px;
    margin: 0 auto;
    ${p => p.theme.breakpoints.down('sm')} {
      width: 592px;
    }
    ${p => p.theme.breakpoints.down('xs')} {
      width: 320px;
    }
  }

  .FormTitle {
    font-weight: 600;
    font-size: 44px;
    line-height: 48px;
    text-align: center;
    letter-spacing: -2px;
    color: ${p => p.theme.webMktPalette.text.primaryBlack};
    padding: 24px 0;
  }

  .FormSubtitle {
    font-weight: normal;
    font-size: 20px;
    line-height: 32px;
    text-align: center;
    letter-spacing: -0.5px;
    color: ${p => p.theme.webMktPalette.text.primaryBlack};
    padding-bottom: 32px;
  }

  .FormFinePrint {
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    color: rgba(0, 0, 0, 0.301961);
    padding: 32px 0;
  }

  .MarketoForm {
    width: 588px;
    margin: 0 auto;
    padding: 32px;
    background: ${p => p.theme.webMktPalette.background.white};
    z-index: 1;
    box-sizing: border-box;
    border-radius: 4px;
    ${p => p.theme.breakpoints.down('xs')} {
      width: 320px;
    }
    form {
      #LblmktoCheckbox_117126_0 {
        color: #4e5758;
        box-sizing: border-box;
        padding-right: 5px;
      }

      .mktoFormRow .mktoFormCol {
        min-height: auto;
      }
    }
  }
`
export default MarketoFormContainer
